import { useCallback } from 'react';

import { push } from 'connected-react-router';
import { CAMPAIGN_CREATION_WIZARD_HISTORY_STATE } from 'utils/campaignCreationWizardFlow/campaignCreationWizardFlow';
import { CREATE_MENU_PAGE_ROUTE } from 'utils/constants/app';
import { CampaignProductType } from 'utils/constants/campaign';

import {
    CampaignTarget,
    setCampaignCreationWizardActiveStep,
    setWizardCampaignTarget,
    setWizardCpcMode,
    setWizardSelectedProductType,
    setWizardSelectedVacancy,
    setWizardWebsiteUrl,
    WizardCpcMode,
} from 'store/models/campaignCreationWizard';
import { useDispatch } from 'store/utils';

export interface WizardRestorationState {
    vacancyId?: number | null;
    vacancyName?: string | null;
    foreignArea?: boolean;
    productType?: CampaignProductType | null;
    cpcMode?: WizardCpcMode | null;
    websiteUrl?: string | null;
    campaignTarget?: CampaignTarget | null;
}

export const useCampaignCreationWizardStepNavigation = (): ((
    activeStep: number,
    wizardState?: WizardRestorationState
) => void) => {
    const dispatch = useDispatch();

    return useCallback(
        (activeStep: number, wizardState?: WizardRestorationState) => {
            if (wizardState?.vacancyId) {
                dispatch(
                    setWizardSelectedVacancy({
                        vacancyId: wizardState.vacancyId,
                        vacancyName: wizardState.vacancyName ?? undefined,
                        foreignArea: wizardState.foreignArea,
                    })
                );
            }
            if (wizardState?.productType !== undefined) {
                dispatch(setWizardSelectedProductType(wizardState.productType));
            }
            if (wizardState?.cpcMode !== undefined) {
                dispatch(setWizardCpcMode(wizardState.cpcMode));
            }
            if (wizardState?.campaignTarget) {
                dispatch(setWizardCampaignTarget(wizardState.campaignTarget));
            }
            if (wizardState?.websiteUrl) {
                dispatch(setWizardWebsiteUrl(wizardState.websiteUrl));
            }
            dispatch(setCampaignCreationWizardActiveStep(activeStep));
            dispatch(push(CREATE_MENU_PAGE_ROUTE, CAMPAIGN_CREATION_WIZARD_HISTORY_STATE));
        },
        [dispatch]
    );
};
